<template>
  <div class="CarNum">
    <div class="content">
      <img :src="img" alt />
    </div>
    <div class="phone">
      <a :href="'tel:'+res.mobile">
        <span>挪车号码:{{res.mobile|phoneFilter}}</span>
      </a>
      <a :href="'tel:'+res.mobile">
        <van-image :src="require('@/assets/images/icon/phone.png')"></van-image>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "CarNum",
  data() {
    return {
      res: {
        mobile: ""
      },
      img: ""
    };
  },
  computed: {},
  async mounted() {
    await this.getImg();
    this.getAll();
  },
  methods: {
    // move_car_stick/moveCarStickPic/get
    async getImg() {
      let result = await this.request(
        "/move_car_stick/moveCarStickPic/get",
        {}
      );
      if (result.code === 0) {
        this.img = result.data.img;
        // console.log(this.list);
      }
    },
    async getAll() {
      // move_car_stick/moveCarStick/getPub
      // 公共的挪车贴信息
      let result = await this.request(
        "/move_car_stick/moveCarStick/getPub",
        {
          id: this.$route.query.id
        }
      );
      if (result.code === 0) {
        this.res = result.data;
        // console.log(this.list);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.CarNum {
  padding: @pad;
  .content {
    img {
      width: 100%;
    }
  }
  .phone {
    margin-top: 30px;
    padding: 0 20px;
    .flex-center();
    justify-content: space-between;
    span {
      .sc(20px, #333);
    }
    .van-image {
      width: 20px;
    }
  }
}
</style>